import RecipeDetailsScreen from "./RecipeDetailsScreenContainer"

export default RecipeDetailsScreen
